import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CashManagementService } from 'src/app/services/cash-management/cash-management.service';
import { GlobalService } from 'src/app/services/shared/global.service';

@Component({
  selector: 'app-cash-transactions',
  templateUrl: './cash-transactions.component.html',
  styleUrls: ['./cash-transactions.component.css']
})
export class CashTransactionsComponent implements OnInit{
  page: number = 1;
  count: number = 0;
  searchText: string = '';
  transactions: any[] = [];
  isLoading:boolean=false;
  public errorMessage: string | null = null;
  form!: FormGroup;
  submitted: boolean = false;

  constructor(
    private cashManagementService: CashManagementService,
    private formBuilder: FormBuilder,
    private globalService: GlobalService,
  ){
    this.form = this.formBuilder.group({
      date_from: ['', Validators.required],
      date_to: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.isLoading=true;
    this.getTransactions();
  }

  getTransactions(): void {
    this.cashManagementService.fetchTransactions()
    .subscribe({
        next: (response) => {
          if(response.status==='success'){
            this.isLoading = false;
            this.transactions = response.data
          }else{
            this.isLoading = false;
            this.errorMessage=response.message;
          }
        },
        error: (error) => {
          this.isLoading = false;
          this.errorMessage=error;
        }
      });
  }

  filterByDate(){
    this.submitted=true;
    this.isLoading = true;

    if (this.form.valid) {
      this.cashManagementService.filterByDate(this.form.value.date_from,this.form.value.date_to)
      .subscribe({
        next: (response) => {
          if(response.status==='success'){
            this.isLoading=false;
            this.transactions = response.data;
            this.page = 1; // Reset to page 1 after applying filter
          }else if(response.status==='no_data'){
            this.isLoading=false;
            this.transactions=[];
            this.globalService.setGlobalWarningMessage(response.message);
          }else{
            this.isLoading=false;
            const errorMessage="Sorry, a problem was encountered while filtering transactions. Please try again!";
            this.globalService.setGlobalErrorMessage(errorMessage);
          }
        },
        error: (error) => {
          this.isLoading=false;
          this.globalService.setGlobalErrorMessage(error);
        }
      });
    }else{
      this.isLoading = false;
    }
  }

  pageChangeEvent(event: number){
    this.page = event;
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
  }
}
